import React, { useEffect, useState } from "react";
import { Lightbulb, Check, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../lib/api";
import { apiErr } from "../../../lib/apiErr";
import { domLabel, fmtWib } from "./signalUtil";

function Item({ s, langs, domains, readOnly, onDone }) {
  const [lang, setLang] = useState(s.lang || "id"); const [dom, setDom] = useState(s.domain ?? ""); const [busy, setBusy] = useState(false);
  const act = async (approve) => {
    setBusy(true);
    try {
      const r = approve ? await api.post("/admin/task-signal-suggestions/approve", { keyword: s.keyword, lang, domain: dom || null }) : await api.delete(`/admin/task-signal-suggestions/${encodeURIComponent(s.keyword)}`);
      if (r.data?.ok === false) { toast.error(r.data.error || "Gagal"); return; }
      toast.success(approve ? `"${s.keyword}" disetujui` : `"${s.keyword}" ditolak`); onDone(approve);
    } catch (e) { toast.error(apiErr(e, "Gagal")); } finally { setBusy(false); }
  };
  return (
    <li className="flex flex-wrap items-center gap-2 rounded-xl border border-line p-3" data-testid={`ts-sug-${s.keyword}`}>
      <div className="min-w-[140px] flex-1"><p className="text-sm font-bold text-slate-900">{s.keyword} <span className="ml-1 font-mono text-[11px] font-semibold text-slate-400">×{s.count}</span></p>
        <p className="text-[10px] text-slate-500">{s.source === "agen" ? "Dialihkan pengguna lewat /agen" : "Dikenali asisten (lapis 2)"} · {fmtWib(s.last_at)}</p></div>
      {!readOnly && <>
        <select value={lang} onChange={(e) => setLang(e.target.value)} className="input-ui w-auto text-xs" data-testid={`ts-sug-${s.keyword}-lang`}>{langs.map((l) => <option key={l} value={l}>{l}</option>)}</select>
        <select value={dom} onChange={(e) => setDom(e.target.value)} className="input-ui w-auto text-xs" data-testid={`ts-sug-${s.keyword}-domain`}><option value="">Umum</option>{domains.map((d) => <option key={d.domain} value={d.domain}>{domLabel(d.domain)}</option>)}</select>
        <button disabled={busy} onClick={() => act(true)} className="btn-primary rounded-xl px-3 py-1.5 text-[11px]" data-testid={`ts-sug-${s.keyword}-approve`}><Check size={12} /> Setujui</button>
        <button disabled={busy} onClick={() => act(false)} className="btn-soft rounded-xl px-3 py-1.5 text-[11px] text-rose-600" data-testid={`ts-sug-${s.keyword}-reject`}><X size={12} /> Tolak</button>
      </>}
    </li>
  );
}

export function SignalSuggestions({ langs, domains, readOnly, onApproved }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/task-signal-suggestions").then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, []);
  return (
    <section className="aivora-card p-5" data-testid="ts-suggestions">
      <p className="mb-1 flex items-center gap-2 text-sm font-bold text-slate-900"><Lightbulb size={15} className="text-amber-500" /> Saran kata kunci</p>
      <p className="mb-3 text-[11px] text-slate-500">Kata yang dikenali asisten sendiri (lapis 2) atau dialihkan pengguna lewat <code className="font-mono">/agen</code>.</p>
      {!items && <div className="h-16 animate-pulse rounded-xl bg-slate-50" />}
      {items && !items.length && <p className="py-4 text-center text-xs text-slate-400" data-testid="ts-sug-empty">Belum ada saran.</p>}
      <ul className="space-y-2">{(items || []).map((s) => <Item key={s.keyword} s={s} langs={langs} domains={domains} readOnly={readOnly} onDone={(ok) => { setItems((x) => x.filter((y) => y.keyword !== s.keyword)); if (ok) onApproved(); }} />)}</ul>
    </section>
  );
}
